<template>
    <div>
        <Header title="Ta initiativet" subtitle="" :background="header_background"/>
        <div id="ways_to_contact" v-if="!mobile">
            <table width="100%">
                <tr>
                    <td width="50%">
                        <div class="item">
                            <i class="fas fa-envelope"></i>
                            <h1>Skicka Mail</h1>
                            <p>
                                För att kontakta oss via mail kan ni antingen använda vårt <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000b5ee5aae819e4305bf8a" target="_blank">kontaktformulär</a> eller skicka mail till:<br><br>
                                <a href="mailto:kontakt@asasbemanning.se" target="_blank">kontakt@asasbemanning.se</a>
                            </p>
                        </div>
                    </td>
                    <td width="50%">
                        <div class="item">
                            <i class="fas fa-phone"></i>
                            <h1>Ring Oss</h1>
                            <p>
                                Vi finns tillgängliga via telefon varje helgfri vardag från 08:00-17:00. Ring oss på:<br><br>
                                0225 - 25 44 00
                            </p>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div id="ways_to_contact" v-else>
            <div class="item">
                <i class="fas fa-envelope"></i>
                <h1>Skicka Mail</h1>
                <p>
                    För att kontakta oss via mail kan ni antingen använda vårt <a href="https://b3.caspio.com/dp.asp?AppKey=78ba2000b5ee5aae819e4305bf8a" target="_blank">kontaktformulär</a> eller skicka mail till:<br><br>
                    <a href="mailto:kontakt@asasbemanning.se" target="_blank">kontakt@asasbemanning.se</a>
                </p>
            </div>
            <div class="item">
                <i class="fas fa-phone"></i>
                <h1>Ring Oss</h1>
                <p>
                    Vi finns tillgängliga via telefon varje helgfri vardag från 08:00-17:00. Ring oss på:<br><br>
                    0225 - 25 44 00
                </p>
            </div>
        </div>
        <div id="map">
            <table>
                <tr>
                    <td v-if="!mobile">
                        <iframe width="450" height="300" style="margin:0px;border:0px;display:block;" frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=Bergslagsgatan+3,+776+30+Hedemora&amp;key=AIzaSyArOFDVr-6jNeeq4r4gn_I4AXnPCFuT_qU"></iframe>
                    </td>
                    <td>
                        <h1>Vårt kontor</h1>
                        <p>
                            Vi befinner oss på Bergslagsgatan 3, 776 30 Hedemora. Vi tar gärna emot besök dock bör ni boka ett möte först. <a v-if="mobile" href="https://goo.gl/maps/8BVMbKYdfqQ3HAmQ6" target="_blank">Öppna karta.</a>
                        </p>
                        <p>
                            Vi hälsar dig välkommen till Åsas Bemanning!
                        </p>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import Footer from "./Footer";
import Header from "./Header";
import header_background from "../assets/img/pavan-trikutam-1660-unsplash.jpg"
export default {
    components: {Footer, Header},
    data() {
        return {
            mobile: window.mobilecheck(),
            header_background: header_background
        }
    },
  name: 'Kontakt',
  props: {
    msg: String
  }
}
</script>

<style scoped>
    @import url("../assets/css/kontakt.module.css");
</style>
